/**
 * Wrapper around generated RTK Query API with cleaner naming and custom logic.
 *
 * All endpoint references (keys, hooks, endpoint map) are derived from the
 * central definitions in `./config.ts` so generated names live in one place.
 */
import { generatedApi } from './api.generated';
import { createEndpointExports, createHookExports } from '@skynet/data-helpers';
import type { HookExports } from '@skynet/data-helpers';
import { AUTH_API_ENDPOINTS as cfg } from './config';

// No cache tags: the Auth API exposes mutations only, so there is no query that
// could provide a tag — an `invalidatesTags: ['Auth']` on `switchTenant` would be
// a no-op. `switchTenantLoader` clears tenant-scoped caches imperatively instead
// (`resetStore` + `resetTenantScopedApiStates`).
export const authApi: typeof generatedApi = generatedApi;

// Re-export hooks with cleaner names via endpoint definitions
export const hookExports: HookExports<typeof cfg, typeof authApi> = createHookExports(cfg, authApi);

// Re-export endpoints object with cleaner names for direct usage
const endpointExports = createEndpointExports(cfg, authApi);

export const authApiEndpoints: typeof endpointExports = endpointExports;

// Re-export for backward compatibility and external use
export { authApiBaseQuery } from './query.base';
export { ensureAccessToken, ReauthBaseQuery } from './query.reauth';
